export const unFlattenResults = (results) =>
   results.map((post) => {
      const { date, slug, tags, title, excerpt, cover } = post;
      return {
         excerpt,
         fields: { slug },
         frontmatter: { title, date, tags, cover },
      };
   });
